module.exports = __webpack_public_path__ + "media/images/top/feature/feature-5-3e87aa9cc5184d36f9dedc79dfdcb5d3.png";